
@if (!initials() && !photo()) {
    <p-avatar icon="pi pi-user" shape="circle" />
}
@else if (initials() && !photo()) {
    <p-avatar class="cursor-pointer" shape="circle"
        pBadge="true" value="!" severity="danger" badgeStyleClass="p-badge-sm" [badgeDisabled]="!notify"
        [pTooltip]="notification" [label]="initials()" tooltipPosition="left"
        (click)="userInfo.toggle($event)"/>
}
@else {
    <p-overlaybadge value="!" severity="danger" badgeSize="small" styleClass="p-badge-sm" [badgeDisabled]="!notify">
        <p-avatar class="cursor-pointer" shape="circle"
        [pTooltip]="notification" [image]="photo()" tooltipPosition="left"
        (click)="userInfo.toggle($event)"/>
    </p-overlaybadge>
    
}



<p-popover #userInfo styleClass="header-user-popover" [style]="{marginLeft:'1.25rem'}">
    <div class="min-w-60"></div>
        <p>{{name()}}</p>
        <p class="italic">{{jobTitle()}}</p>
</p-popover>
